import { create } from 'zustand';

/**
 * "Open as request" from outside the API Client (the terminal's links, card 4
 * of the Terminal board): the caller drops a draft here and App, where
 * `createNewRequestTab` lives, opens it as a new unsaved request tab
 * (hooks/useRequestDraftOpen) — the same hand-off as useSharedRequestOpen.
 */
export const useRequestDraftStore = create(() => ({ draft: null }));

/** Ask App to open `{ method, url, name? }` as a new request tab. */
export const openRequestDraft = (draft) => useRequestDraftStore.setState({ draft: draft ? { method: 'GET', ...draft } : null });

export const clearRequestDraft = () => useRequestDraftStore.setState({ draft: null });
